<template>
  <div class="container">
    <h2>Oh no!</h2>
    <p>You tried to access a page, which does not exist.</p>
    <p>Please reload the page and navigate by the top navigation bar.</p>
  </div>
</template>

<script>
  export default {
    name: 'Error'
  }
</script>

<style scoped lang="scss">
  @import '../style/bootstrap-component-include';
</style>
